import { render, staticRenderFns } from "./EditarEtiqueta.vue?vue&type=template&id=3ea327d0"
import script from "./EditarEtiqueta.vue?vue&type=script&lang=js"
export * from "./EditarEtiqueta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports